'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'sun-bright';
var width = 512;
var height = 512;
var aliases = ["sun-alt"];
var unicode = 'e28f';
var svgPathData = 'M232 488l0 24 48 0 0-104-48 0 0 80zm0-408l0 24 48 0 0-104-48 0 0 80zM92 58L58 92c7.5 7.5 26.4 26.4 56.6 56.6l17 17 33.9-33.9c-7.5-7.5-26.4-26.4-56.6-56.6L92 58zM380.5 346.5l-33.9 33.9 73.5 73.5 33.9-33.9-73.5-73.5zM0 232l0 48 104 0 0-48-104 0zm408 0l0 48 104 0 0-48-104 0zM58 420L92 454c7.5-7.5 26.4-26.4 56.6-56.6l17-17-33.9-33.9c-7.5 7.5-26.4 26.4-56.6 56.6L58 420zM346.5 131.5l33.9 33.9c7.5-7.5 26.4-26.4 56.6-56.6L454 91.9 420 58c-7.5 7.5-26.4 26.4-56.6 56.6l-17 17zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSunBright = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;